import Layout from "@/components/feature/Layout";
import PageHeader from "@/components/feature/PageHeader";
import TeamSection from "@/components/feature/TeamSection";
import About from "@/pages/home/components/About";
import Vision from "@/pages/home/components/Vision";

export default function Nosotros() {
  return (
    <Layout>
      <PageHeader
        eyebrow="Nosotros"
        title="Historia, visión y equipo"
        subtitle="Más de 17 años de trayectoria construyendo viviendas y condominios de calidad en la Región Metropolitana."
      />
      <About />
      <Vision />
      <TeamSection />
    </Layout>
  );
}